import { LogOut, Menu, Settings } from 'lucide-react';

interface User {
  id: string;
  email?: string;
}
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@deckspace/ui';

interface TitleBarProps {
  workspaceName?: string | null;
  user: User | null;
  onSignOut: () => void;
  onSettingsClick: () => void;
  onHomeClick: () => void;
}

export function TitleBar({
  workspaceName,
  user,
  onSignOut,
  onSettingsClick,
  onHomeClick,
}: TitleBarProps) {
  return (
    <header className="h-10 flex-shrink-0 flex items-center bg-background border-b border-border px-2">
      <div className="flex items-center gap-2 min-w-0">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className="w-7 h-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              title="Menu"
            >
              <Menu size={15} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem onClick={onSettingsClick}>
              <Settings size={14} />
              Settings
            </DropdownMenuItem>
            {user && (
              <DropdownMenuItem onClick={onSignOut}>
                <LogOut size={14} />
                Log out
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
        <button
          onClick={onHomeClick}
          className="text-xs font-bold tracking-widest text-foreground uppercase select-none hover:text-foreground/70 transition-colors"
          title="Home"
        >
          Deckspace
        </button>
      </div>

      <div className="flex-1 flex justify-center min-w-0">
        {workspaceName && (
          <span className="text-base font-semibold text-foreground truncate max-w-md">
            {workspaceName}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2 min-w-0" />
    </header>
  );
}
